import { render, staticRenderFns } from "./CakaTab.vue?vue&type=template&id=f32c9126&scoped=true&"
import script from "./CakaTab.vue?vue&type=script&lang=js&"
export * from "./CakaTab.vue?vue&type=script&lang=js&"
import style0 from "./CakaTab.vue?vue&type=style&index=0&id=f32c9126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c9126",
  null
  
)

export default component.exports